import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const FileUserIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M7 4C6.44772 4 6 4.44772 6 5V19C6 19.5523 6.44772 20 7 20H9C9.55228 20 10 20.4477 10 21C10 21.5523 9.55228 22 9 22H7C5.34315 22 4 20.6569 4 19V5C4 3.34315 5.34315 2 7 2H13.5858C14.1162 2 14.6249 2.21071 15 2.58579L19.4142 7C19.7893 7.37507 20 7.88378 20 8.41421V11.6563C20 12.2086 19.5523 12.6563 19 12.6563C18.4477 12.6563 18 12.2086 18 11.6563V10H15C13.3431 10 12 8.65685 12 7V4H7ZM14 4.41421V7C14 7.55228 14.4477 8 15 8H17.5858L14 4.41421ZM15.4861 15C14.8861 15 14.3998 15.4864 14.3998 16.0863C14.3998 16.6863 14.8861 17.1726 15.4861 17.1726C16.086 17.1726 16.5724 16.6863 16.5724 16.0863C16.5724 15.4864 16.086 15 15.4861 15ZM12.3998 16.0863C12.3998 14.3818 13.7816 13 15.4861 13C17.1906 13 18.5724 14.3818 18.5724 16.0863C18.5724 17.4313 17.712 18.5754 16.5116 18.9982H17.0508C18.3294 18.9982 19.4242 19.7755 19.8927 20.8793C20.1085 21.3877 19.8713 21.9747 19.3629 22.1905C18.8545 22.4063 18.2674 22.1691 18.0517 21.6607C17.8856 21.2695 17.4988 20.9982 17.0508 20.9982H13.9213C13.4734 20.9982 13.0866 21.2695 12.9205 21.6607C12.7047 22.1691 12.1177 22.4063 11.6093 22.1905C11.1009 21.9747 10.8637 21.3877 11.0795 20.8793C11.548 19.7755 12.6428 18.9982 13.9213 18.9982H14.4606C13.2601 18.5754 12.3998 17.4313 12.3998 16.0863Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

FileUserIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(FileUserIcon);
